import request from '@/config/request'

export default {
  searchCommentOrder: function (orderCode) {
    return request({
      url: '/order/comment/searchcommentorder',
      method: 'get',
      params: {
        ordercode: orderCode,
      }
    })
  },
  insertComment: function (data) {
    return request({
      url: '/order/comment/insertcomment',
      method: 'post',
      data: data
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/order/comment.js